export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user"));
  } catch {
    return null;
  }
};

export const getClinicId = () => {
  const user = getUser();
  return user?.clinic_id || user?.clinic || null;
};
